import React, { useState } from "react";
import Select from "react-select";

import { getEducationLevelResult, getEducationFieldResult } from "api/search.api";
import { debounce } from "lodash";
import { createNameLabelArray } from "utils";
import SearchFilterDropdown from "components/Common/SearchableDropdown/SearchFilterDropdown";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/store";
import { IKeywordOption } from "components/Filters/AddKeywords";
import { addEducationFields, removeEducationFields } from "store/slices/searcSlice";

interface ResponseData {
  value: string;
  label: string;
  extra?: string;
}
interface EduFieldSelectProps {
  onSelect?: (selectedOption: ResponseData | null) => void;
  styles?: any; // Optional: Allow custom styles to be passed
  isMulti?: boolean; 
  isBorder?: boolean;
  isSmall?: boolean;
}

const EduFieldSelect: React.FC<EduFieldSelectProps> = ({ onSelect, styles, isMulti = true, isBorder, isSmall }) => {
  const [options, setOptions] = useState<ResponseData[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const dispatch = useDispatch();

  const selectedFields = useSelector((state: RootState) => state.search.education_fields);

  const handleChange = (selected: IKeywordOption[] | null) => {
    const selectedValues = selected ? selected.map((option) => option.value) : [];
    const lastSelectedValue = selectedValues[selectedValues.length - 1];
    dispatch(addEducationFields(lastSelectedValue));
  };

  const handleDeselect = (value: string | null) => {
    if (value) {
      dispatch(removeEducationFields(value));
    }
  };

  const fetchOptions = (inputValue: string) => {
    setLoading(true);
    getEducationFieldResult(inputValue)
      .then((result: any) => {
        setOptions(createNameLabelArray(result));
      })
      .catch((error) => {
        console.error("Error fetching industry list:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const debouncedFetchOptions = debounce(fetchOptions, 300);

  const handleInputChange = (inputValue: string) => {
    if (inputValue.length > 2) {
      debouncedFetchOptions(inputValue);
    }
  };

  return (
    <SearchFilterDropdown
      mode="multiple"
      options={options}
      loading={loading}
      onChange={(values: string[]) =>
        handleChange(values.map((value) => ({ value, label: value })))
      }
      defaultValue={selectedFields}
      handleDeselect={handleDeselect}
      onInputChange={handleInputChange}
      isBorder={isBorder}
      isSmall={isSmall}
    />
  );
};

export default EduFieldSelect;
